import Store from 'lightningjs-redux';
import config from '@bedrock-rdk/config';
import { initializeApp } from '../../../logic/app/app.actions';
import { setDeeplinkLocation } from '../../../logic/routing/routing.actions';
import { setContentTemplateOptions } from '../../../logic/layout/layout.actions';
import { getContentTemplateOptions } from '../../tornado/templates';

export const boot = () => {
  Store.dispatch(setDeeplinkLocation(window.location.hash.replace(/^#/, '')));
  Store.dispatch(setContentTemplateOptions(getContentTemplateOptions()));

  return Store.dispatch(initializeApp(config));
};
